import { Chakra } from "@airhelp/react-ui-components";
import { useMemo } from "react";
import getPaginationPages from "./utility";
import type { PaginationProps } from "./Pagination.d";
import PagesList from "./PagesList";
import NextButton from "./NextButton";
import PrevButton from "./PrevButton";

const { HStack } = Chakra;

const Pagination = ({
  previousPage,
  canPreviousPage,
  pages,
  nextPage,
  canNextPage,
  gotoPage,
  currentPage,
}: PaginationProps) => {
  const memoPages = useMemo(() => getPaginationPages(pages, currentPage), [currentPage, pages]);

  return (
    <HStack color="primary.500">
      <PrevButton previousPage={previousPage} canPreviousPage={canPreviousPage} />
      <PagesList pages={memoPages} onPageClick={gotoPage} currentPage={currentPage} />
      <NextButton nextPage={nextPage} canNextPage={canNextPage} />
    </HStack>
  );
};

export default Pagination;
